function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import App from 'modules/App';
import { formatDate } from 'helpers/datetime';
import intlShape from 'shapes/intlShape';
import ContourLogo from 'svg/mobileReports/Contour-logo.svg';
import messages from '../../../messages';
import styles from './Header.pcss';
var _React_Component;
class Header extends (_React_Component = React.Component) {
    render() {
        const { accountPatientProfile, phiSet, conversion, standards } = this.props;
        if (!accountPatientProfile || !phiSet) return null;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.headerDailyLogReport,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.headerDailyLogReport__left,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            children: `${accountPatientProfile.firstName} ${accountPatientProfile.lastName}`
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                children: `${App.messages.diabetesTypes[phiSet.diabetesType] ? `${this.props.intl.formatMessage(App.messages.diabetesTypes[phiSet.diabetesType])}` : '-'}`
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.dateOfBirth)}:
              ${accountPatientProfile.dateOfBirth ? formatDate(accountPatientProfile.dateOfBirth) : '-'}`
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                children: accountPatientProfile.email
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.headerDailyLogReport__header,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(ContourLogo, {
                                className: styles.headerDailyLogReport__logo
                            })
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            className: styles.headerDailyLogReport__title,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.title))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.headerDailyLogReport__right,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.beforeMealTarget)}: ${conversion.toDisplay(standards.preMeal.lowThreshold)} - ${conversion.toDisplay(standards.preMeal.highThreshold)} ${conversion.unitSymbol}`
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.afterMealTarget)}: ${conversion.toDisplay(standards.postMeal.lowThreshold)} - ${conversion.toDisplay(standards.postMeal.highThreshold)} ${conversion.unitSymbol}`
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.criticalLow)}: < ${conversion.toDisplay(standards.critical.lowThreshold)} ${conversion.unitSymbol}`
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx("span", {
                                children: `${this.props.intl.formatMessage(messages.glucoseReport.criticalHigh)}: > ${conversion.toDisplay(standards.critical.highThreshold)} ${conversion.unitSymbol}`
                            })
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(Header, "propTypes", {
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit props
    phiSet: PropTypes.object,
    accountPatientProfile: PropTypes.object,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        critical: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    conversion: PropTypes.object
});
export default withStyles(styles)(injectIntl(Header));
